import React from "react";
import Image from "react-bootstrap/Image";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Accordion from "react-bootstrap/Accordion";
import clsx from "clsx";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faQuestionCircle} from "@fortawesome/free-solid-svg-icons";
import {useHistory} from "react-router";

function Faq (){
    const history = useHistory();

    const onClickLogin = (e) => {
        e.preventDefault();
        history.push(`/auth/login`);
    };

    return (
      <>
        <div className="wrapper">
          <div className="main-panel">
            <Navbar className="default-bg">
              <Container
                fluid
                className="d-flex flex-row justify-content-between align-items-center"
              >
                <div className="d-flex align-items-center ml-2 ml-lg-0 main-logo">
                  <Image
                    src="/img/ta-securities-logo.png"
                    className="brandLogo"
                    alt="logo"
                  />
                </div>

                <div className="d-none d-sm-block d-xs-none">
                  <Nav className="nav mr-auto" navbar>
                    <button
                      className={clsx("btn btn-primary m-0 ms-2")}
                      style={{ border: "1px solid lightgrey" }}
                      onClick={(e) => onClickLogin(e)}
                    >
                      Back to Login
                    </button>
                  </Nav>
                </div>
              </Container>
            </Navbar>

            <div className="content content-bg position-relative mt-4 mb-4">
              <div className="container">
                <div
                  className={"primary-border-table-border"}
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className={clsx(
                      "d-flex custom-card-label-container align-items-center",
                    )}
                  >
                    <h2>Frequently Asked Questions (FAQ)</h2>
                  </div>
                </div>
                <div className={clsx("faq mt-2")}>
                  <Accordion flush className="faq-accordion">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        What is TA Client Portal?
                      </Accordion.Header>
                      <Accordion.Body>
                        TA Client Portal is an online platform that provide client with
                        access to electronic services.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1" className={clsx("mt-1 mb-1")}>
                      <Accordion.Header>
                        What type of features can I get from the TA Client
                        Portal?
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          You can access and perform the following features
                          (where applicable):
                        </p>
                        <ol style={{ listStyleType: "upper-roman" }}>
                          <li>
                            <span className={"text-decoration-underline"}>
                              e-Payment
                            </span>
                            <br />
                            Online & off-line payment via FPX, internet banking,
                            cash deposit machine & etc on the outstanding
                            position.
                          </li>
                          <li>
                            <span className={"text-decoration-underline"}>
                              e-Deposit
                            </span>
                            <br />
                            Online & off-line deposit to trust account via FPX,
                            internet banking, cash deposit machine & etc.
                          </li>
                          <li>
                            <span className={"text-decoration-underline"}>
                              e-Setoff
                            </span>
                            <br />
                            Online request to off-set outstanding position with
                            sales proceeds and trust funds.
                          </li>
                          <li>
                            <span className={"text-decoration-underline"}>
                              e-Withdrawal
                            </span>
                            <br />
                            Online request withdrawing funds from the trust
                            account to the registered e-Share Payment (ESP)
                            account.
                          </li>
                          <li>
                            Enquiry your account portfolio on outstanding
                            purchase and sales, view transactions.
                          </li>
                        </ol>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2" className={clsx("mt-1 mb-1")}>
                      <Accordion.Header>
                        Who can access TA Client Portal?
                      </Accordion.Header>
                      <Accordion.Body>
                        You must be TA Securities Holdings Berhad client with
                        registered email. Only open to Retail and Margin
                        Account for both Individual and Corporate Clients.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3" className={clsx("mt-1 mb-1")}>
                      <Accordion.Header>
                        How to access TA Client Portal?
                      </Accordion.Header>
                      <Accordion.Body>
                        You may access TA Client Portal via web browser at
                        https://eservices.tasecurities.com.my by keying in your
                        client code as your login ID and Password to login.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4" className={clsx("mt-1 mb-1")}>
                      <Accordion.Header>
                        How to activate TA Client Portal?
                      </Accordion.Header>
                      <Accordion.Body>
                        <ol style={{ listStyleType: "upper-roman" }}>
                          <li>
                            Click First Time Login Activation button at login
                            page.
                          </li>
                          <li>Input valid client code & registered email.</li>
                          <li>
                            First-Time login activation link will be send to the
                            registered email.
                          </li>
                          <li>Creates new password.</li>
                        </ol>
                        <p>
                          If you have not registered or your email address
                          differs from your registered email with the company,
                          kindly contact your Dealer Representative to register
                          or update your email. with the company
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5" className={clsx("mt-1 mb-1")}>
                      <Accordion.Header>
                        Why is my ID suspended and how to re-activate it?
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          Please take note that we apply the following security
                          measures to protect our customers:
                        </p>
                        <ol style={{ listStyleType: "upper-roman" }}>
                          <li>
                            Suspend access upon 3 consecutives invalid login
                            attempts.
                          </li>
                          <li>Suspend access upon customer's request.</li>
                          <li>
                            Suspend access by the system administrator at our
                            sole discretion.
                          </li>
                        </ol>
                        <p>
                          Upon suspension, please contact us if you wish to
                          re-activate the access to your client portal.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="6" className={clsx("mt-1 mb-1")}>
                      <Accordion.Header>
                        How to contact you us for help assistance?
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          You may contact us via email or phone call if you need
                          any assistance.
                        </p>
                        <ol style={{ listStyleType: "upper-roman" }}>
                          <li>
                            Email address:{" "}
                            <a href="mailto:taonline@ta.com.my">
                              taonline@ta.com.my
                            </a>
                          </li>
                          <li>
                            Contact number:{" "}
                            <a href="tel:+60321679799">
                              603 2167 9799 (Helpdesk)
                            </a>
                          </li>
                        </ol>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
}

export default Faq